<nav [ngClass]="{ centered: centered }" [tabPanel]="tabPanel" class="tab-nav-bar__list" color="accent" mat-tab-nav-bar>
  @for (item of navLinks$ | async; track item) {
    @if (item?.visible) {
      <a
        #rla="routerLinkActive"
        (click)="onTabLinkClick(item)"
        [active]="rla.isActive"
        [routerLink]="item.link"
        class="tab-nav-bar__item"
        mat-tab-link
        routerLinkActive
      >
        {{ item.label | translate | uppercase }}
      </a>
    }
  }
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
